export const SHOW_NAVIGATION_MENU = "SHOW_NAVIGATION_MENU";
export const HIDE_NAVIGATION_MENU = "HIDE_NAVIGATION_MENU";

export function showNavigationMenu() {
  return {
    type: SHOW_NAVIGATION_MENU,
  };
}
export function hideNavigationMenu() {
  return {
    type: HIDE_NAVIGATION_MENU,
  };
}
